module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "buildings"
    }
  }, [_c('el-row', {
    staticClass: "headLine"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("产业空间信息（存量商务楼宇）")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 12
    }
  }, [(_vm.type == 1) ? _c('a', {
    staticClass: "downLink",
    attrs: {
      "href": _vm.downloadUrl,
      "download": ""
    }
  }, [_vm._v("导入模版下载")]) : _vm._e(), _vm._v(" "), (_vm.type == 1) ? _c('el-button', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.excelHandle
    }
  }, [_vm._v("导入Excel")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "90px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.newList
    }
  }, [_vm._v("刷新")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "navLine"
  }, [_c('div', {
    class: ['navItem', {
      'act': _vm.navAct == 1
    }],
    on: {
      "click": function($event) {
        _vm.navChange(1)
      }
    }
  }, [_vm._v("楼宇信息")]), _vm._v(" "), _c('div', {
    class: ['navItem', {
      'act': _vm.navAct == 2
    }],
    on: {
      "click": function($event) {
        _vm.navChange(2)
      }
    }
  }, [_vm._v("空间信息")])]), _vm._v(" "), (_vm.navAct == 1) ? _c('BuildingList', {
    ref: "buildingList",
    attrs: {
      "type": _vm.type
    }
  }) : _vm._e(), _vm._v(" "), (_vm.navAct == 2) ? _c('FloorList', {
    ref: "floorList",
    attrs: {
      "type": _vm.type
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-93a0c580"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/industryInfos/buildingsView/index.vue
// module id = 1543
// module chunks = 1